/** @format */
import {ForwardedRef, forwardRef} from 'react';

import {RatingProps} from '@mui/lab';

import {StarBorderRounded, StarRateRounded} from '@mui/icons-material';

import {StyledRating} from './styles';

const CustomRating = forwardRef(
  ({...props}: RatingProps, ref: ForwardedRef<HTMLInputElement>) => {
    return (
      <StyledRating
        ref={ref}
        icon={<StarRateRounded />}
        emptyIcon={<StarBorderRounded />}
        {...props}
      />
    );
  },
);

CustomRating.displayName = 'CustomRating';

export {CustomRating};
